import React, { Component } from 'react';
import { translate } from '../../services';
import { PropTypes } from 'prop-types';

export class ClipboardProductImport extends Component {  
  constructor() {
    super();
    this.productInput = '';
    this.accessoriesInput = '';
  }

  update() {
    const { position } = this.props;
    this.props.updateProduct( position, this.productInput, this.accessoriesInput );
  }

  updateAccessories = e => {
    this.accessoriesInput = e.target.value.toUpperCase();
    this.update();
  }

  updateProduct = e => {
    this.productInput = e.target.value.replace( ',', '' ).toUpperCase();
    this.update();
  }
    
  render() {
    const { product } = this.props;
    const productCode = product && product.product || '';
    let accessories = product && product.accessories ? product.accessories.join( ', ' ) : '';

    if( this.accessoriesInput.endsWith( ',' ) ) {
      accessories += ', ';
    }

    return <div className="clipboard-product-import">
      <input value={ productCode } className="product-input" placeholder={ translate( 'Insert a product code' ) } onChange={ this.updateProduct }/>
      <input value={ accessories } className="accessory-input" placeholder={ translate( 'Insert an accessory list (comma separated)' ) } onChange={ this.updateAccessories }/>
    </div>;
  }
}

ClipboardProductImport.propTypes = {
  position: PropTypes.number.isRequired,
  product: PropTypes.shape( {
    product: PropTypes.string,
    accessories: PropTypes.arrayOf( PropTypes.string )
  } ),
  updateProduct: PropTypes.func.isRequired
};